<template>
	<div class="main-contents input">		
		<div class="tit">모집중인 프로젝트</div>
		<div class="search-box">			
			<SelectComp type="select" class="wd05" :isAll="true" list="2:수행예정,1:수행중" title="프로젝트 상태" v-model="input.projectStatusTemp"/><nbsp />			
			<SelectComp type="select" class="" list="1:프로젝트명,2:프로젝트 담당자명,3:매니저명,4:수행사명" v-model="input.searchGubun"/>						
			<InputComp type="text" :placeholder="input.searchGubun == '1' ? '프로젝트명' : input.searchGubun == '2' ? '프로젝트 담당자명' : input.searchGubun  == '3' ? '매니저명' : '수행사명'" v-model="input.searchKeyword" @keyup.enter="getList('1')"  />
			<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getList('1')"/>
		</div>
		
		<div class="Board type3">
			<table class="Board_type3 admin total">
				<colgroup> <!-- 3, 32, 17, 11, 11, 8, 9, 9 -->
					<col width="3%">
					<col width="34%">
					<col width="12%">
					<col width="15%">
					<col width="8%">
					<col width="8%">
					<col width="14%">
					<col width="12%">
				</colgroup>
				<thead>
					<tr>
						<th>NO</th>
						<th>프로젝트명</th>
						<th>고객사명</th>
						<th>프로젝트 기간</th>
						<th>등록일</th>
						<th>프로젝트 상태</th>
						<th>지원IT프로</th>
						<th>인터뷰 현황</th>
					</tr>
				</thead>
				<tbody>

					<tr v-for="(project, index) in projectList" :key="project.projectSeq">
						<td class="score">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}</td>
						<td class="score name" @click="clickProjectInfo(project.projectSeq)">
							<div class="rc_tag" v-if="project.apprYn != 'Y'">
								<div class="rc_mark_red">미 승 인</div>
							</div>
							<div class="rc_tag" v-else>
								<div v-if="(project.recrStartYyyymmdd <= nowYyyymmdd && project.recrEndYyyymmdd >= nowYyyymmdd) && project.recrEndDateDiff >= 0" class="rc_mark">+모집중</div>
							</div>
							{{project.projectNm}}
						</td>
						<td class="score">{{project.clientNm}}</td>
						<td class="score">
							{{ project.projectStartEndYyyymmdd }}
						</td>
						<td class="score" v-if="project.contractYyyymmdd == undefined || project.contractYyyymmdd == null">-</td><td class="score" v-else>{{project.contractYyyymmdd| date('yyyy.MM.dd')}}</td>
						<td class="score">
							<span v-if="project.projectStatus == 1"><div class="state pf"></div>수 행 중</span>
							<span v-else-if="project.projectStatus == 2"><div class="state ep"></div>수행예정</span>
							<span v-else-if="project.projectStatus == 9"><div class="state cp"></div>수행완료</span>
						</td>
						<td class="score resume">
							{{ project.appMberCnt }}명<nbsp n="3"></nbsp><div class="btn" @click="goDetail(project.projectSeq, 'app')">지원IT프로 보기 &#9654;</div>
						</td>
						<td class="score resume"><div class="btn" @click="goDetail(project.projectSeq, 'intv')">인터뷰 현황 보기 &#9654;</div></td>
					</tr>
					
					<!-- 등록된 프로젝트가 없을 경우 -->
					<tr v-if="pageInfo.totalRecordCount == 0">
						<td colspan="8" class="none">프로젝트가 없습니다.</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- 페이징부분 -->
		<paging-comp :pageInfo="pageInfo" @page-click="goPage"/>
	</div>
</template>
<script>
import pagingComp from '@/components/PagingComp.vue';

export default {
	components: { pagingComp },
	data() {
		return {
			input : {
				searchGubun : '1',		// 1:프로젝트명, 2:담당자명, 3:매니저명, 4:수행사명, 5: 공급사명
				projectStatus : ['0'],	// 0:모집중, 1:수행중, 2:수행예정, 9:완료
				projectStatusTemp : '',
				searchKeyword: '',

				projectStatusAnd : 'Y',	// 프로젝트 상태 조회시 모집중 and (수행중 or 수행예정) 으로 조회하기 위한 구분값
			},
			
			nowYyyymmdd : '',

			selectedIndex : '',
			intvStatDiv : '',
			tecMberSeq : '',
			selectedRow : {},

			projectList : {},
			pageInfo : {},

			projectTecMberList : [],
			projectSeqTecMber : '',

			chgProjectSeq : this.$route.params.chgProjectSeq,
		};
	},

	beforeMount() {
	},

	mounted(){

		// console.log('chgProjectSeq', this.chgProjectSeq);

		this.nowYyyymmdd = new Date().format("yyyyMMdd");

		var keys = Object.keys(this.input);
		for(var key in this.$route.params){
			if(keys.indexOf(key) >= 0){
				this.input[key] = this.$route.params[key];
			}
		}

		this.getList();
	},
	methods: {
        getList(div, isScroll = false){

			if(div) this.input.pageIndex = 1;
			
			this.input.projectStatus = ['0'];	// 모집중인 프로젝트 화면으로 모집중 상태는 항상 조회

			if(this.input.projectStatusTemp != '') {
				this.input.projectStatus.push(this.input.projectStatusTemp);
			}

            this.$.httpPost('/api/prj/adm/getProjectList', this.input)
                .then(res => {
					// console.log('res.data', res.data);

                    this.projectList = res.data.list;
                    this.pageInfo = res.data.pageInfo;

					this.projectSeqTecMber = '';

					if(this.chgProjectSeq) {
						for(var i in this.projectList) {
							if(this.projectList[i].projectSeq == this.chgProjectSeq) {
								this.projectList[i].isOpenTecMber = true;
								this.projectSeqTecMber = this.chgProjectSeq
								this.getTecMberList(this.projectSeqTecMber);
							}
						}
					}else if(this.projectList.length > 0 && this.projectList[0].passMberCnt + this.projectList[0].mberCntFail + this.projectList[0].mberCntInterview + this.projectList[0].inputMberCnt  >= 0) {
						// 참여IT프로 조회
						if(this.$route.params.prjSeq) {
							this.getTecMberList(this.$route.params.prjSeq);
						} else {
							this.projectList[0].isOpenTecMber = true;
							this.projectSeqTecMber = this.projectList[0].projectSeq;
							this.getTecMberList(this.projectSeqTecMber);
						}
						// this.projectList[0].isOpenTecMber = true;
						// this.projectSeqTecMber = this.projectList[0].projectSeq;
						// this.getTecMberList(this.projectSeqTecMber);
						
					}

                    if(isScroll) {
						window.scroll(0, 0);
					}
				})
                .catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
        }, 
		
		getTecMberList(projectSeq) {

			var input = {
				projectSeq : projectSeq
			};

			// console.log(input);

			this.selectedIndex = '';
			this.intvStatDiv = '';
			
			this.$.httpPost('/api/prj/adm/getRecruitProjectTecMberList', input)
				.then(res => {
					// console.log('getRecruitProjectTecMberList', res.data);
					this.projectTecMberList	= res.data.projectTecMberList;

					this.projectSeqTecMber = projectSeq;

					if(this.chgProjectSeq) {
						this.$.focus(this.$refs[this.chgProjectSeq]);
						this.chgProjectSeq = '';
					}
					if(this.$route.params.prjSeq) {
						this.$.focus(this.$refs[this.$route.params.prjSeq]);
					}

				}).catch(this.$.httpErrorCommon);
		},	
		
		openTecMber(project) {
			this.getTecMberList(project.projectSeq);
		},

		closeTecMber() {	
			this.projectSeqTecMber = '';		
			// this.$forceUpdate();
		},		
		
		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList();
		},

		clickProjectInfo(projectSeq) {

			var viewId = 'PRJ911M03'

			var params = {
				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

			this.$router.push({name: viewId, query : {projectSeq : projectSeq}, params });

		},	

		popupMber(mberSeq) {
			var param = {};
			param.reqMberSeq = mberSeq;
			param.div = 'tec'; // tec - 개인, gmg - 관리총괄, pmg - 프로젝트 담당자, sco - 파트너사, agt - 매니저

			this.$.popup('/adm/mem/MEM923P02', param);
		},		

		// 프로젝트 담당 매니저 정보 보기
		popupAdmMgerMber(admMgrMberSeq) {
			var param = {};
			param.reqMberSeq = admMgrMberSeq;
			param.div = 'agt'; // tec - 개인, gmg - 관리총괄, pmg - 프로젝트 담당자, sco - 파트너사, agt - 매니저

			this.$.popup('/adm/mem/MEM923P02', param);
		},

		// 참여기간 변경
		changeJoinStartEndYyyymmdd(projectSeq, mberSeq) {
			alert('프로젝트 참여기간 변경 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},

		// 평가보기
		viewEval(projectSeq, mberSeq) {
			alert('평가보기 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},

		// 평가요청
		reqEval(projectSeq, mberSeq) {
			alert('평가요청 개발 해야 함 projectSeq : ' + projectSeq + ', mberSeq : ' + mberSeq);
		},
		
		// IT프로 투입 / 교체투입
		// div : 1 - 투입, 2 - 교체투입
		tecMberPut(obj) {
			var param = {};
			param.projectSeq = obj.projectSeq;
			param.div = "1";

			this.$router.push({name:'PRJ911M02', query:param, params:{projectNm:obj.projectNm, div:1}});
		},

		// IT프로 상태변경
		// intvStatDiv : 1 - 인터뷰 요청, 2 - 합격, 3 - 불합격, 4 - 불합격 및 교체
		btnModify(obj) {
			if(!this.editable(obj)) return alert('총괄관리자 또는 담당매니저만 IT프로 상태변경이 가능합니다.');
			if(!this.intvStatDiv) {
				alert('IT프로 상태변경을 선택하세요.');
				return false;
			}

			if(obj.projectDivCd.substr(0,1) == '3') {
				if(!confirm('해당 프로젝트는 파트너사 지정 프로젝트 입니다.\n계속 진행하시겠습니까?')) {
					return false;
				}
			}

			if(Object.keys(this.selectedRow).length == 0) {
				alert('IT프로를 선택하세요.');
				return false;
			}
			
			var param = {};

			if(this.intvStatDiv == '1') {
				param = this.selectedRow
				param.projectSeq = obj.projectSeq;
				param.corpNm = this.selectedRow.corpNm != undefined ? this.selectedRow.corpNm : '소속없음';
				
				if(param.interviewStatusCd == '04') {
					alert('해당 IT프로는 이미 합격했습니다.');
					return false;
				}

				this.$.popup('/adm/prj/PRJ911P01', param)
					.then(res => {
						if(res) this.getTecMberList(obj.projectSeq);
					})
			}else if(this.intvStatDiv == '2') {
				param.tecMberSeq = this.selectedRow.mberSeq;
				param.projectSeq = obj.projectSeq;
				param.interviewReqSeq = this.selectedRow.interviewReqSeq;
				param.corpNm = this.selectedRow.corpNm != undefined ? this.selectedRow.corpNm : '소속없음';
				param.workCont = this.selectedRow.workCont

				this.$.popup('/adm/prj/PRJ911P02', param)
					.then(res => {
						if(res) this.getTecMberList(obj.projectSeq); this.getProjectMberCnt(obj.projectSeq);
					})
			}else if(this.intvStatDiv == '3') {
				param.tecMberSeq = this.selectedRow.mberSeq;
				param.projectSeq = obj.projectSeq;
				param.interviewReqSeq = this.selectedRow.interviewReqSeq;
				param.corpNm = this.selectedRow.corpNm != undefined ? this.selectedRow.corpNm : '소속없음';

				this.$.popup('/adm/prj/PRJ911P03', param)
					.then(res => {
						if(res) this.getTecMberList(obj.projectSeq); this.getProjectMberCnt(obj.projectSeq);
					})
			}else if(this.intvStatDiv == '4') {
				param.targetMberSeq = this.selectedRow.mberSeq;
				param.projectSeq = obj.projectSeq;
				param.interviewReqSeq = this.selectedRow.interviewReqSeq;
				param.corpNm = this.selectedRow.corpNm != undefined ? this.selectedRow.corpNm : '소속없음';
				param.div = '2';
				param.type = '1';

				this.$.popup('/adm/prj/PRJ911P04', param);
			}
			
		},

		getProjectMberCnt(seq) {
			this.$.httpPost('/api/prj/adm/getProjectMberCnt', {projectSeq : seq})
				.then(res => {
					// console.log('getProjectMberCnt RESULT', res);

					for(var i in this.projectList) {
						if(this.projectList[i].projectSeq == seq) {
							this.projectList[i].passMberCnt = res.data.passMberCnt;
							this.projectList[i].mberCntFail = res.data.mberCntFail;
							this.projectList[i].mberCntInterview = res.data.mberCntInterview;
							this.projectList[i].inputMberCnt = res.data.inputMberCnt;
						}
					}

				}).catch(this.$.httpErrorCommon);
		},

		editable(project){
			return this.$store.state.userInfo.mberDivCd == '00'				//총괄관리자
				|| this.$store.state.userInfo.mberSeq == project.admMgrMberSeq;//담당매니저
		},

		goDetail(projectSeq, pageDiv) {
			var viewId = 'PRJ911M04'
			if(pageDiv == 'intv') viewId = 'PRJ911M05';

			var params = {
				prjtSeq : projectSeq,
				caller : {
					name: this.$route.name,
					params: this.input
				}
			}

			this.$router.push({name: viewId, params});
		}
	},
};
</script>
